import getCombatantLastRoundAction from './getCombatantLastRoundAction'

export default function getCombatantLastRoundActionImage(combatant, maxCA) {
  console.log('IN getCombatantLastRoundActionImage combatant = ', combatant.name, ' maxCA = ', maxCA)
  const img = getCombatantLastRoundAction(combatant, maxCA).image
  console.log('IN getCombatantLastRoundActionImage img = ', img)
  return img
}
